import { useMutation } from '@tanstack/react-query';
import { axios } from 'lib/axios';

export const assignUser = (data) => {
  const { adId, assignedUserId } = data;
  return axios.patch(`/api/job_ads/${adId}/assign`, { assigned_user_id: assignedUserId });
};

export const useAssignUser = (config) => {
  return useMutation({
    ...config,
    mutationFn: assignUser,
  });
};